// extracted by mini-css-extract-plugin
export var contentWithCount = "DestinationCard-module--content-with-count--6eb28";
export var cruiseCount = "DestinationCard-module--cruise-count--40104";